import { Button } from "primereact/button"
import React, { useState, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import TableComponent from "../../component/Tables/tableComponent"
import { setDataAssetActiveTab, submitTempRuleRecommendation } from "../../redux/dataAsset/dataAsset.action"
import { ProgressSpinner } from "primereact/progressspinner"
import { SET_FORM_OPTION } from "../../redux/dataAsset/dataAsset.type"

function RecommendationPopUp({ dataAssetId, onHide }) {
    const { dataAssetActiveTab,apiData, formData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()

    const getColumns = () => {
        return [
            { field: "attribute_name", header: "Column Name" },
            { field: "dimension_name", header: "Dimension" },
            { field: "rule_name", header: "Rule Name" },
            { field: "rule_description", header: "Rule Description" },
            { field: "check_name", header: "DQ Rule Check" },
        ]
    }



    return (
        <PopUpScreen header={<Fragment>Recommendations</Fragment>} onHide={onHide} style={{ width: '90%', maxHeight: "90%" }} >
            {apiData.recommendateRule.loading ?
                <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div> :
                <Fragment>
                    <TableComponent scrollable scrollHeight="60vh" style={{ height: "100%" }} selection={formData.ruleRecommendationform.options} onSelectionChange={(e) => {
                        dispatch({
                            type: SET_FORM_OPTION,
                            payload: {
                                // TO DO: not sure about this
                                formField: "ruleRecommendationform",
                                data: e.value
                            }
                        })
                    }} tableData={apiData.recommendateRule.data} columns={getColumns()} checked={true} />
                    <div className="grid">
                        <div className="col-12" style={{ marginTop: "20px", marginBottom: "-20px", textAlign: "right" }}>
                            <Button outlined onClick={() => {
                                dispatch({
                                    type:SET_FORM_OPTION,
                                    payload:{
                                        formField:"ruleRecommendationform",
                                        data: []
                                    }
                                })
                                onHide()
                            }} label="Cancel" style={{ marginRight: "10px" }} />
                            <Button onClick={() => {
                                 dispatch(setDataAssetActiveTab(dataAssetActiveTab+1))
                                dispatch(submitTempRuleRecommendation(dataAssetId))
                                dispatch({
                                    type:SET_FORM_OPTION,
                                    payload:{
                                        formField:"ruleRecommendationform",
                                        data: []
                                    }
                                })
                                onHide()
                            }
                            } disabled={formData.ruleRecommendationform.options.length === 0} label="Add Rule" icon="pi pi-arrow-right" iconPos="right" />
                        </div>
                    </div>
                </Fragment>}
        </PopUpScreen>
    )
}

export default RecommendationPopUp